<template>
    <CalendarPrev
        v-bind="forwardedProps"
        :as="DsIconButton"
        icon="fa-solid fa-chevron-left"
        size="sm"
        tooltipText="Previous month"
    >
    </CalendarPrev>
</template>

<script lang="ts" setup>
import DsIconButton from '@/components/design-system/DsIconButton.vue';
import { reactiveOmit } from '@vueuse/core';
import type { CalendarPrevProps } from 'reka-ui';
import { CalendarPrev, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<CalendarPrevProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
